import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import LoginPage from "./pages/login/login";
import SignupPage from "./pages/signup";
import HomePage from "./pages/home/home";
import ProtectedRoute from "./components/ProtectedRoute";
import TestCaseView from "./components/TestCase/testCaseView";
import Logout from "./components/LogoutComponent";
import React, { useEffect } from "react";
import "../src/globalStyle/global.css";
import PermissionEnum from "../src/enums/PermissionEnum";
import ChangePassword from "./components/Profile/Profile";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme"; // Import your custom theme
import GlobalSnackbar from "./components/snackbar/GlobalSnackbar";
import PasswordAction from "./pages/resetPassword/PasswordAction";
import DEFAULT_ROUTES from "./constants/routes";
import GhostLoader from "./components/Loaders/ghostloader";
import { useDispatch, useSelector } from "react-redux";
import { setLoadingRedux } from "./features/commonslice";
import LoginComponent from "./pages/login";
import { LicenseInfo } from "@mui/x-license";
import withAuthenticatedData from "./components/hoc/withAuthenticatedData";
import LandingPage from "./pages/landing/LandingPage";
import DocsPage from "./pages/docs/DocsPage";
import NotFoundPage from "./components/NotFound/NotFoundPage";
import { DocsConfigProvider } from "./pages/docs/context/DocsConfigContext";
import LegalDocumentPage from "./pages/legal/LegalDocumentPage";
import ConsentGate from "./components/consent/ConsentGate";

// License key for MUI Pro
LicenseInfo.setLicenseKey('df89b5813d67d14d27c09989497d69b9Tz0xMjkzNjAsRT0xODEwNzcxMTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');

// Stable component references at module level — prevents HOC identity from being
// recreated on every App re-render, which would cause remount churn and trigger
// fetchUserLogin() calls (→ 401s) mid-login on every Redux dispatch.
const HomePageWithAuthenticatedData = withAuthenticatedData(HomePage);
const ProfilePageWithAuthenticatedData = withAuthenticatedData(ChangePassword);
const LoginPageWithAuthenticatedData = withAuthenticatedData(LoginComponent);
const SignupPageWithAuthenticatedData = withAuthenticatedData(SignupPage);

function App() {
  const { loading } = useSelector((state) => state.common);
  // const loading = false;

  const routesData = [
    {
      path: DEFAULT_ROUTES.ROOT,
      element: loading ? <GhostLoader /> : <LandingPage />,
    },
    {
      path: `${DEFAULT_ROUTES.DOCS}/*`,
      element: (
        <DocsConfigProvider>
          <DocsPage />
        </DocsConfigProvider>
      ),
    },
    // {
    //   path: DEFAULT_ROUTES.LOGIN,
    //   element: <LoginPage />,
    // },
    {
      path: DEFAULT_ROUTES.TERMS,
      element: <LegalDocumentPage documentType="tos" />,
    },
    {
      path: DEFAULT_ROUTES.PRIVACY,
      element: <LegalDocumentPage documentType="privacy" />,
    },
    {
      path: DEFAULT_ROUTES.LOGOUT,
      element: <Logout />,
    },
    {
      path: DEFAULT_ROUTES.LOGIN,
      element: <LoginPageWithAuthenticatedData />,
    },
    {
      path: DEFAULT_ROUTES.SIGNUP,
      element: <SignupPageWithAuthenticatedData />,
    },
    {
      path: DEFAULT_ROUTES.TEST_CASE_VIEW,
      element: loading ? <GhostLoader /> : <TestCaseView />,
    },
    {
      path: DEFAULT_ROUTES.CHANGE_PASSWORD,
      element: <ProfilePageWithAuthenticatedData />,
    },
    {
      path: DEFAULT_ROUTES.RESET_PASSWORD,
      element: <PasswordAction type="reset" />,
    },
    {
      path: DEFAULT_ROUTES.SET_PASSWORD,
      element: <PasswordAction type="set" />,
    },
    {
      path: `${DEFAULT_ROUTES.BASE_URL}/*`,
      element: <HomePageWithAuthenticatedData />,
    },
    { path: "*", element: <NotFoundPage /> },
  ];

  

  return (
    <ThemeProvider theme={theme}>
      <GlobalSnackbar />
      {
        <Router>
          <ConsentGate />
          <Routes>
            {routesData.map((route, index) => {
              return (
                 <Route key={index} path={route.path} element={route.element} />
              )
            })}
          </Routes>
        </Router>
      }
    </ThemeProvider>
  );
}

export default App;
